import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  List,
  Stack,
  Text,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import React from "react";
import pdf from "../Assert/Kiran_Wankhade_Resume.pdf";

import avatar from "../kiran_photo.png";

import { FaAngleRight, FaGithub, FaLink } from "react-icons/fa";

import "./Education.css";
import { Link } from "react-router-dom";

const Education = () => {
  return (
    <>
      <hr
        className="hrClass"
        style={{
          height: 5,
          backgroundColor: "#29242a",
        }}
      />
      <div id="education" className="education">
        <Box className="mainaeducation" color={"#dcdcda"}>
          <Box>
            <Heading
              textDecoration={"underline"}
              fontSize={50}
              textUnderlineOffset="10px"
              textDecorationStyle={"solid"}
              textDecorationColor={"orange"}
              color={"#15110D"}
            >
              My Education{" "}
            </Heading>
            <br />
            <br />
          </Box>

          <div className="educationClass">
            <UnorderedList className="educationBox">
              <ListItem>
                <Box className="educationDetails">
                  <Text fontWeight={"bold"}>FULL STACK DEVELOPMENT</Text>
                  <Text>Masai School (Full Time)</Text>
                  <Text>
                    -I have Experienced 2100+ hours on coding.
                    <br />
                    -I have learned most of the things from in here.
                  </Text>
                </Box>

                <Box>July 2022 - April 2023</Box>
              </ListItem>
              <ListItem>
                <Box className="educationDetails">
                  <Text fontWeight={"bold"}>iOS DEVELOPMENT</Text>
                  <Text>BRN Infotech, Hyderabad</Text>
                  <Text>
                    -Learned the how iOS application work.
                    <br />
                    -Implement iOS application using swift language.
                   
                  </Text>
                </Box>

                <Box>Aug 2018 - March 2019</Box>
              </ListItem>
              <ListItem>
                <Box className="educationDetails">
                  <Text fontWeight={"bold"}>Bachelor in Engineering</Text>
                  <Text>SSGB-COET (NMU)</Text>
                  <Text>
                    -Completed my Bachelor degree in Computer Science and Engineering.
                    
                  </Text>
                </Box>

                <Box>July 2013 - July 2018</Box>
              </ListItem>
            </UnorderedList>
          </div>
          <br />

          <br />
          <br />
        </Box>
      </div>
    </>
  );
};

export default Education;
